export default Object.freeze({
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    TIKTOK: 'tiktok',
    LINKEDIN: 'linkedIn',
    TWITTER: 'twitter',
    GOOGLE: 'googleBusiness',
})
